/**
 * Maximum character counter for input and textarea fields
 */

import $ from 'jquery';

import { Foundation } from 'foundation-sites/js/foundation.core';

class MaxInputLength {
    constructor(element, options) {
        this.$element = element;
        this.$field = $('[data-max-input-field]', element);
        this.$label = $('[data-max-input-label]', element);
        this.$alert = $('[data-max-input-alert]', element);
        this.warning = this.$alert.data('max-input-warning');
        this.exact = this.$alert.data('max-input-exact');
        this.error = this.$alert.data('max-input-error');
        this.is_sh_widget = $('[data-soft-hyphen]', element).length;
        this.options = $.extend({}, MaxInputLength.defaults, this.$element.data(), options);

        const that = this;
        // update count when key is released
        this.$field.on('input', () => that.updateCount.call(that));

        Foundation.registerPlugin(this, 'MaxInputLength');
    }

    updateCount() {
        let count = this.$field.val().length;
        // for softhyphenstringwidgets, do not count the softhyphen replacement
        if (this.is_sh_widget) {
            // use regexp to filter out the sh replacement
            count -= (this.$field.val().match(/\u205e/g)||[]).length;
        }
        const left = this.options.max - count;
        // start warning after the warning margin was passed
        if (left < this.options.error) {
            if (!this.$label.hasClass('limit-error')) {
                this.$label.removeClass('limit-warning').addClass('limit-error');
                this.$alert.html(this.error);
            }
        } else if (left == this.options.error) {
            this.$label.removeClass('limit-error').addClass('limit-warning');
            this.$alert.html(this.exact);
        } else if (left < this.options.warning) {
            if (!this.$label.hasClass('limit-warning') || this.$alert.html()!=this.warning) {
                this.$label.removeClass('limit-error').addClass('limit-warning');
                this.$alert.html(this.warning);
            }
        // else branch combined with class check
        } else if (this.$label.hasClass('limit-error') || this.$label.hasClass('limit-warning')) {
            this.$label.removeClass('limit-error').removeClass('limit-warning');
            this.$alert.html('');
        }
        this.$label.text(left);
    }
}

MaxInputLength.defaults = {
    max: 100,
    warning: 11,
    error: 0
};

Foundation.plugin(MaxInputLength, 'MaxInputLength');
